import { render, staticRenderFns } from "./RemoveUIPlugins.vue?vue&type=template&id=41f62665&scoped=true&"
import script from "./RemoveUIPlugins.vue?vue&type=script&lang=js&"
export * from "./RemoveUIPlugins.vue?vue&type=script&lang=js&"
import style0 from "./RemoveUIPlugins.vue?vue&type=style&index=0&id=41f62665&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f62665",
  null
  
)

export default component.exports